export enum PaymentType {
	GoPayApplePay = "GoPayApplePay",
	GoPayGPay = "GoPayGPay",
	GoPayPaymentCard = "GoPayPaymentCard",
	// GoPayPayPal = "GoPayPayPal",
	GoPayQRCode = "GoPayQRCode",
	OnDelivery = "OnDelivery",
	OnInvoice = "OnInvoice",
	WithoutInvoice = "WithoutInvoice",
}
